<template>
  <div>
    <div :class="{'clickable': !readonly && !disabled, 'color-preview': true}" :style="'background-color: ' + inputVal + ';'" @click="togglePicker($event)" />
    <div class="color-picker-modal-area">
      <material-color-picker
        v-if="showPicker && type==='material'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <compact-color-picker
        v-if="showPicker && type==='compact'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <swatches-color-picker
        v-if="showPicker && type==='swatches'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <slider-color-picker
        v-if="showPicker && type==='slider'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <sketch-color-picker
        v-if="showPicker && type==='sketch'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <chrome-color-picker
        v-if="showPicker && type==='chrome'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
      <photoshop-color-picker
        v-if="showPicker && type==='photoshop'"
        :value="colorVal"
        @input="updateValue"
        @ok="onOk"
        @cancel="onCancel"
        @reset="onReset"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'photoshop'
    },
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      inputVal: '',
      colorVal: {},
      showPicker: false
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
      this.colorVal.hex = newVal
      this.currentVal = newVal
    },
    hasError: function(newVal) {
      this.$forceUpdate()
    }
  },
  mounted() {
    this.inputVal = this.value
    this.colorVal.hex = this.value
    if ((this.readonly || this.disabled) && !this.value) {
      this.inputVal = '#007700'
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
      this.$forceUpdate()
    }
  },
  methods: {
    updateValue(val) {
      if (this.readonly || this.disabled) {
        return
      }
      this.currentVal = val.hex
      this.$forceUpdate()
    },
    togglePicker() {
      if (this.readonly || this.disabled) {
        return
      }
      this.showPicker = !this.showPicker
      this.$forceUpdate()
    },
    onOk() {
      this.showPicker = !this.showPicker
      this.inputVal = this.currentVal
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
      this.$forceUpdate()
    },
    onCancel() {
      this.showPicker = !this.showPicker
      this.inputVal = this.value
      this.$forceUpdate()
    },
    onReset() {
      this.inputVal = this.value
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.color-preview {
  height: 33px;
}
.color-picker-area.form-control {
  height: auto;
  padding: 0;
  padding-right: 35px;
}
.color-picker-modal-area > div {
  width: 100%;
}
</style>
